"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomDropZone = void 0;
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
var React = require("react");
var react_1 = require("react");
var react_dropzone_1 = require("react-dropzone");
exports.CustomDropZone = function (_a) {
    var dropEvent = _a.dropEvent;
    var _b = react_1.useState([]), myFiles = _b[0], setMyFiles = _b[1];
    var baseStyle = {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        padding: '20px',
        borderWidth: 2,
        borderRadius: 2,
        borderColor: '#eeeeee',
        borderStyle: 'dashed',
        backgroundColor: '#fafafa',
        color: '#bdbdbd',
        outline: 'none',
        transition: 'border .24s ease-in-out'
    };
    var activeStyle = {
        borderColor: '#2196f3'
    };
    var acceptStyle = {
        borderColor: '#00e676'
    };
    var rejectStyle = {
        borderColor: '#ff1744'
    };
    var onDrop = react_1.useCallback(function (acceptedFiles) {
        if (acceptedFiles.length > 0) {
            setMyFiles(__spreadArrays(myFiles, acceptedFiles));
        }
    }, [myFiles]);
    var _c = react_dropzone_1.useDropzone({ onDrop: onDrop, accept: 'image/*' }), getRootProps = _c.getRootProps, getInputProps = _c.getInputProps, isDragActive = _c.isDragActive, isDragAccept = _c.isDragAccept, isDragReject = _c.isDragReject, acceptedFiles = _c.acceptedFiles;
    var style = react_1.useMemo(function () { return (__assign(__assign(__assign(__assign({}, baseStyle), (isDragActive ? activeStyle : {})), (isDragAccept ? acceptStyle : {})), (isDragReject ? rejectStyle : {}))); }, [
        isDragActive,
        isDragReject,
        isDragAccept
    ]);
    var files = myFiles.map(function (file) { return (React.createElement("li", { key: file.name, style: { color: "rgba(84, 82, 82, 0.94)" } }, file.name)); });
    var removeAll = function () {
        if (acceptedFiles.length > 0) {
            setMyFiles(__spreadArrays(myFiles, acceptedFiles));
            dropEvent(acceptedFiles);
        }
        setMyFiles([]);
    };
    return (React.createElement("section", { className: "container", style: { padding: 0 } },
        React.createElement("div", { className: "container", style: { padding: 0 } },
            React.createElement("div", __assign({}, getRootProps({ style: style })),
                React.createElement("input", __assign({}, getInputProps())),
                React.createElement("p", null, "Bilder hier herreinziehen oder klicken, um Bilder auszuw\u00E4hlen"))),
        React.createElement("aside", { style: { paddingTop: "15px", display: myFiles.length > 0 ? "block" : "none" } },
            React.createElement("p", { style: { fontSize: "22px", fontWeight: 600, color: "rgba(84, 82, 82, 0.94)" } }, "Bilder, die hochgeladen werden:"),
            React.createElement("ul", null, files),
            React.createElement(office_ui_fabric_react_1.PrimaryButton, { className: "ms-Default-Button2", onClick: removeAll, text: "Hochladen" }))));
};
//# sourceMappingURL=CustomDropZone.js.map